import Head from 'next/head'

export default function CovidNoticePage() {
  return (
    <>
      <Head>
        <title>COVID Statement</title>
      </Head>
      <div className="pageContainer">
        <h1 className="h1">COVID Statement</h1>
        <p>
          The health and safety of our staff and clients is of paramount
          importance to us.
          <br />
          As such we have taken the following measures to keep everyone safe:
        </p>
        <ul className="list">
          <li>Hand sanitisers near the entrances</li>
          <li>Gloves and masks available for staff and clients to use</li>
          <li>
            Signage informing everyone to stay a minimum of 2m apart when in the
            showroom
          </li>
          <li>Regular cleaning of the showroom</li>
          <li>Regular sanitisation of the work stations</li>
        </ul>
        <p>
          We are open Monday to Friday 9am to 5pm and Saturday 9am to 4pm.
          <br />
          We look forward to helping you with your home renovation.
        </p>
      </div>
    </>
  )
}
